import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(localStorage.getItem("tokens") || "");
  const setTokens = (data) => {
    localStorage.setItem("tokens", data);
    setAuth(data);
  };
  return (
    <AuthContext.Provider value={{ auth, setAuth: setTokens }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
